import axios from "axios";
import { MEETINGS_AI_BACK_URL } from "@/config";
import { getUserTimezone } from "@/utils/dates";

const axiosCoachingAI = axios.create({
    baseURL: MEETINGS_AI_BACK_URL,
});

axiosCoachingAI.interceptors.request.use((config) => {
    const token = localStorage.getItem("accessToken");
    if (token) config.headers["Authorization"] = `Bearer ${token}`;
    config.headers["X-Timezone"] = getUserTimezone();
    return config;
});

export default axiosCoachingAI;
